module.exports = __webpack_public_path__ + "assets/561a7a6085ae4bc2934eb1e60a7f2eb0.webm";